module.exports = __webpack_public_path__ + "img/h5img37.28530228.png";